
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cataloghi",
      function () {
        return require("private-next-pages/cataloghi/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cataloghi"])
      });
    }
  